import React from 'react';
import {
  Alert,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  TextField,
} from '@mui/material';

interface EditNotesDialogProps {
  open: boolean;
  label: string;
  initialValue: string;
  saving?: boolean;
  error?: string | null;
  onClose: () => void;
  onSave: (value: string) => Promise<void> | void;
}

export const EditNotesDialog: React.FC<EditNotesDialogProps> = ({
  open,
  label,
  initialValue,
  saving = false,
  error = null,
  onClose,
  onSave,
}) => {
  const [value, setValue] = React.useState(initialValue);

  React.useEffect(() => {
    if (open) {
      setValue(initialValue);
    }
  }, [initialValue, open]);

  const handleSave = async () => {
    if (saving) return;
    await onSave(value);
  };

  return (
    <Dialog open={open} onClose={saving ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2 }}>
        {error && <Alert severity="error">{error}</Alert>}
        <TextField
          autoFocus
          fullWidth
          multiline
          minRows={4}
          maxRows={10}
          label={label}
          value={value}
          onChange={(event) => setValue(event.target.value)}
          disabled={saving}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={saving}>Cancel</Button>
        <Button
          variant="contained"
          onClick={handleSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={18} color="inherit" /> : undefined}
        >
          {saving ? 'Saving...' : 'Save Notes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};